<template>
  <div class="d-flex justify-content-between align-items-center">
    <div class="d-flex align-items-center">
      <div v-show="filterData.length && filterItems.tag.length" class="">
        <span class="header">FILTERS APPLIED:</span>
      </div>
      <div v-show="filterData.length && filterItems.tag.length" class="">
        <div class="">
          <div 
            class="mx-2"
            v-for="(data, idx) in filterData"
            :key="idx"
          >
            <div class="chip" style="border: 1px solid #0300133D !important;">
              <span class="sub-header">{{ data.field }}: </span>
              <span style="font-size: 15px;">{{ data.value }}</span>
              <span class="closebtn" @click="removeFilter(idx, data.field)">&times;</span>
            </div>
          </div>
        </div>
      </div>
      <div v-show="filterData.length && filterItems.tag.length" class="">
        <b-button class="custom-button py-1" size="sm" @click="removeFilter">
          Clear Filters
        </b-button>
      </div>
    </div>
    <div class="d-flex align-items-center">
      <div class="px-3">
        <span>Filters:</span>
      </div>
      <div class="">
        <div class="row justify-content-end px-3">
            <div>
              <label class="pr-3 mb-0">
                <b-input-group class="advance-search-field">
                  <b-form-input
                    v-model="filter"
                    type="search"
                    placeholder="Search..."
                    class="form-control form-control-md SearchInput"
                    @keydown.enter.native="onUpdateFilter"
                  ></b-form-input>
                  <b-input-group-prepend class="btn2 btn2-tertiary">
                    <span 
                      class="input-group-text bg-white" 
                      :class="1 == 2 ? '' : 'right-search-border'" 
                      @click="onUpdateFilter"
                    >
                      <i class="uil-search"></i>
                    </span>
                  </b-input-group-prepend>
                  <!-- <b-input-group-prepend class="btn2 btn2-tertiary" v-if="false">
                    <span class="input-group-text bg-white right-search-border" @click="showAdvanceSeach = !showAdvanceSeach"><i class="uil-sliders-v" style="transform: rotate(270deg);"></i></span>
                  </b-input-group-prepend> -->
                </b-input-group>
                <!-- <b-input-group 
                  v-show="showAdvanceSeach" 
                  class="w-100 px-3 custom-advance-search mt-1 mr-2" 
                >
                  <hrflow-fields-search
                    hasButton
                    ref="advanceSearch"
                    class="w-100"
                    @onSearchField="onSearch"
                  />
                </b-input-group> -->
              </label>
            </div>
            <div style="width: 180px;">
              <multiselect
                ref="Tag"
                autocomplete
                :multiple="true"
                v-model="filterItems.tag"
                :options="tagOptions"
                :searchable="true"
                placeholder="Tag"
                :clear-on-select="false"
                :close-on-select="false"
                :show-labels="false"

                track-by="name"
                label="name"
                @input="onInputFilter(filterItems.tag, 'Tag')"
                @remove="onRemoveFilters(filterItems.tag, 'Tag')"
              >
              <template #selection="{ values, search, isOpen }">
                <span class="multiselect__single"
                      v-if="values.length"
                      v-show="!isOpen">{{ values.length }} tag(s) selected
                </span>
              </template>
            </multiselect>
            </div>

          
        </div>

    
      </div>
    </div>

  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'

export default {
  components: {
    Multiselect,
  },
  props:{
  },
  computed: {
 
  },
  data() {
    return {
      tagOptions: [],
      filterItems: {
        tag: '',
      },
      filterData: [],
      filter: ''
    }
  },
  methods:{
    onInputFilter(val, field) {

      if(Array.isArray(val)) {
        val.name = val.map(value => value.name).join(", ")
      }

      let data = this.filterData
      let newData = []
      let isFilter = false
      let value = typeof val == 'object' ?  val.name : val
      if(val && field){
        for(let key in data){
          let item = data[key].field
          if(item == field){
            isFilter = true
            data[key].value = value
          }
          newData.push(data[key])
        }
  
        if(isFilter){
          this.filterData = newData
        }else{
          this.filterData.push({
            field: field,
            value: value
          })
        }
      }

      this.onUpdateFilter()
    },
    removeFilter(idx, field) {
      if(field){
        let formattedField = this.camelize(field)
        this.filterItems[`${formattedField}`] = ''
        this.filterData.splice(idx, 1)
      }else{
        this.filterData = []
        this.filterItems = {
          tag: '',
        }
      } 
      
      this.onUpdateFilter()
    },
    onUpdateFilter(){
      let items = this.filterItems && typeof this.filterItems == 'object' ? this.filterItems : ''

      let filter = {
        tag: items && items.tag && items.tag.length ? items.tag.map( val => val._id) : [],
        filter: this.filter || '',
      }
      this.$emit('onFilter', filter || '')
    },
    fetchFilterOptions(){
      this.$store.dispatch('tag/all')
      .then(res => {
        this.tagOptions = res.data
      })
    },
    camelize(str) {
      return str
        .replace(/\s(.)/g, function($1) { return $1.toUpperCase(); })
        .replace(/\s/g, '')
        .replace(/^(.)/, function($1) { return $1.toLowerCase(); });
    },
    onRemoveFilters(val, field) {
      if(val.length == 1 && field) {
        for(let key in this.filterData) {
          if(this.filterData[key].field == field) {
            this.removeFilter(parseInt(key), field)
          }
        }
      }
    }
  },
  mounted(){
    this.fetchFilterOptions()
  },
}
</script>